/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ERROR_MESSAGE } from 'src/app/_helpers/utils';
import { FormBase } from 'src/app/_models/form-base';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mat-form-field',
  templateUrl: './mat-form-field.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInput,
    MatIcon,
  ],
  styleUrl: './mat-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatFormFieldComponent {
  hidePassword = true;

  /** Field form base (required) */
  field = input<FormBase<string>>();

  /** Parent FormGroup containing the control (required) */
  parentForm = input<FormGroup>();

  /** Icon name used in the form field (optional) */
  iconName = input<string | undefined>(undefined);

  public get hasErrors(): boolean {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return false;
    const ctrl = form.controls[f.key];
    return !!(ctrl && ctrl.errors && ctrl.touched);
  }

  public get errorsList(): string[] {
    const form = this.parentForm();
    const f = this.field();
    if (!form || !f) return [];
    const ctrl = form.controls[f.key];
    if (!ctrl || !ctrl.errors) return [];
    return Object.keys(ctrl.errors).map((err: string) => {
      const fn = ERROR_MESSAGE[err];
      return fn ? fn(ctrl.getError(err)) : 'Unknown error';
    });
  }
}
